<template>
  <div>
    <common-header title="Audience">
      <template #btn>
        <el-col style="width: 65px" v-show="selections.length">
          <download-csv
            v-if="
              CONSTANT.USER_LEVEL_FILTER.ALL.includes(
                userInfo.service.user_level
              )
            "
            :data="selections"
            :fields="['name', 'jsTag', 'imagePixel']"
            :labels="{
              name: 'Name',
              jsTag: 'JS Tag',
              imagePixel: 'Image Pixel',
            }"
            name="audiences.csv"
          >
            <el-button class="btn btn-default btn-outline-blue">
              <i class="fas fa-file-download"></i>
            </el-button>
          </download-csv>
        </el-col>
        <el-col style="width: 65px">
          <el-button
            class="btn btn-default btn-outline-pink"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.MID.includes(
                userInfo.service.user_level
              )
            "
            @click="showDialog({ type: CONSTANT.DIALOG_TYPE.AUDIENCE })"
          >
            <i class="fas fa-user-plus"></i>
          </el-button>
        </el-col>
      </template>
    </common-header>
    <el-table
      :data="
        audiences.filter(
          (data) =>
            !search || data.name.toLowerCase().includes(search.toLowerCase())
        )
      "
      row-key="_id"
      @selection-change="setSelections"
      @row-contextmenu="rowContextMenu"
      @row-dblclick="rowDblclick"
      style="font-size: 18px"
      empty-text="No audience! Let's create a new audience!"
      border
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="55"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="Name"
        min-width="300"
        sortable
      ></el-table-column>
      <el-table-column
        prop="lifetime"
        label="Life time"
        min-width="200"
        sortable
      >
        <template slot-scope="{ row }"
          >{{ row.lifetime }} D</template
        >
      </el-table-column>
      <el-table-column
        prop="size"
        label="Unique User Size"
        min-width="200"
        sortable
      ></el-table-column>
      <el-table-column align="right" width="250">
        <template slot="header" slot-scope="{ row }">
          <el-input v-model="search" placeholder="search" />
        </template>
        <template slot-scope="{ row }">
          <el-button
            class="btn btn-outline-pink"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.MID.includes(
                userInfo.service.user_level
              )
            "
            @click="showDialog({ type: CONSTANT.DIALOG_TYPE.AUDIENCE, row })"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="Edit"
              placement="bottom"
            >
              <i class="fas fa-pen"></i>
            </el-tooltip>
          </el-button>

          <el-button
            class="btn btn-outline-pink"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.ALL.includes(
                userInfo.service.user_level
              )
            "
            @click="copy('JS code', row.jsTag)"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="Copy JS code"
              placement="bottom"
            >
              <i class="far fa-clone"></i>
            </el-tooltip>
          </el-button>
          <el-button
            class="btn btn-outline-pink"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.ALL.includes(
                userInfo.service.user_level
              )
            "
            @click="copy('image pixel', row.imagePixel)"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="Copy image pixel"
              placement="bottom"
            >
              <i class="far fa-clone"></i>
            </el-tooltip>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <dialogs></dialogs>
    <context-menus></context-menus>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import JsonCSV from "vue-json-csv";
import CommonHeader from "@/components/base/header";
import Dialogs from "@/components/common/dialogs/index";
import ContextMenus from "@/components/common/contextMenus/index";
import MixFunc from "@/components/mixins/base";
export default {
  data() {
    return {
      search: "",
      selections: [],
    };
  },
  components: {
    DownloadCsv: JsonCSV,
    CommonHeader,
    Dialogs,
    ContextMenus,
  },
  mixins: [MixFunc],
  computed: {
    ...mapState({
      audiences: (state) => state.audience.audiences,
      userInfo: (state) => state.user.userInfo,
    }),
  },
  async created() {
    if (!this.audiences.length) {
      await store.dispatch("audience/getAudiences");
    }
  },
  methods: {
    ...mapActions({
      showContextMenu: "showContextMenu",
      showDialog: "showDialog",
    }),
    rowContextMenu(row, col) {
      if (col.label) {
        this.showContextMenu({ type: CONSTANT.MENU_TYPE.AUDIENCE, row });
      }
    },
    rowDblclick(row) {
      this.showDialog({ type: CONSTANT.DIALOG_TYPE.AUDIENCE, row });
    },
    setSelections(val) {
      this.selections = val;
    },
  },
};
</script>

<style></style>
